var _rect, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 2,
    height: 14,
    fill: "#429E71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999998 6C0.999998 4.89543 1.89543 4 3 4L10 4L10 18C10 19.1046 9.10457 20 8 20L3 20C1.89543 20 0.999999 19.1046 0.999999 18L0.999998 6Z",
    fill: "#64AB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9807C12.0001 18.0048 12.2041 20.042 14.4278 22.36C16.6631 24.6901 19.2647 27.3012 19.2647 27.3012C19.2647 27.3012 19.8235 30.2137 20.3824 30.7962C20.6759 31.1021 21.1852 31.0126 21.6026 30.8585C22.0623 30.689 22.383 30.2728 22.5219 29.7857C22.6736 29.2538 22.8412 28.5216 22.8412 27.8835C22.8412 26.7185 22.2824 24.9709 22.2824 24.9709L20.6632 20.9996C20.5292 20.6707 20.7711 20.3108 21.1262 20.3108L28.5163 20.3108C29.1551 20.3108 29.7676 20.096 30.2193 19.7137C30.671 19.3313 30.8871 18.8127 30.8871 18.272C30.8871 17.7312 30.671 17.2126 30.2193 16.8303C29.7676 16.4479 29.1551 16.2331 28.5163 16.2331L28.7421 16.2331C29.3808 16.2331 29.9934 16.0183 30.4451 15.636C30.8967 15.2536 31 14.7251 31 14.1843C31 13.6436 30.8967 13.1349 30.4451 12.7526C29.9934 12.3702 29.3808 12.1554 28.7421 12.1554L28.0647 12.1554C28.7035 12.1554 29.3161 11.9406 29.7677 11.5582C30.2194 11.1759 30.4355 10.6573 30.4355 10.1166C30.4355 9.57582 30.2194 9.05723 29.7677 8.67488C29.3161 8.29252 28.7035 8.07771 28.0647 8.07771L27.2368 8.07771C27.8756 8.07771 28.4882 7.8629 28.9398 7.48054C29.3915 7.09818 29.5323 6.57959 29.5323 6.03885C29.5323 5.49812 29.3915 4.97952 28.9398 4.59716C28.4882 4.2148 27.8756 4 27.2368 4C27.2368 4 22.0803 4 20.4294 4C18.7785 4 12 4 12 4C12 4 12 16.109 12 17.9807Z",
    fill: "#64AB88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 16.5,
    r: 1.5,
    fill: "#F6F4F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.96c18b3635a5173b792a66be24faf733.svg";
export { ForwardRef as ReactComponent };